import { useLocation } from 'react-router-dom';
import { useApp } from 'App';
import { Container, Link } from './Styles';
import config from 'config';

const Fotter = () => {
  const { pathname } = useLocation();
  const { state } = useApp();
  const { user } = state;
  const { privacyPolicy, termsConditions, contactSupport } = config.info;
  return (
    <Container $isLoginPage={pathname === '/login'}>
      <Link href={privacyPolicy}>Privacy Policy</Link>
      <Link href={termsConditions}>Terms and Conditions</Link>
      <Link href={contactSupport + '?tSe=6' + (user ? `&uid=${user.uId}` : '')}>Contact Support</Link>
    </Container>
  );
};
export default Fotter;
